import React, { FC, memo } from 'react';
import { IDataGridMadel } from '../../model';
import Size from './size';
import Pager from './pager';
import { useI18n } from 'AurionCR/components';

const Pagination: FC<React.PropsWithChildren<{
  model: IDataGridMadel;
  pagination: any;
  onTasks: any;
}>> = ({ model, pagination, onTasks }) => {
  const { t } = useI18n();
  if (!model || !model.pagination.visible) return null;

  return (
    <div className="data-grid-pagination">
      <div className="size">
        {model.pagination.sizes.visible && (
          <Size model={model} onTasks={onTasks} pagination={pagination} />
        )}
        {Boolean(pagination.total_) && (
          <span className="total">
            {t('total')}: <span>{pagination.total_}</span>
          </span>
        )}
      </div>
      <Pager pagination={pagination} onTasks={onTasks} />
    </div>
  );
};

export default memo(Pagination);
